import React from 'react';
import { flex } from '@fabric-ui/theme';
import { Box, Divider } from '@mui/material';
import { NumberConditionType } from '../../types/filter.types';
import { generateUUID } from '../../utils/utils';
import { FormattingRule } from '../../views/FormattingRules/types';
import { operatorLabels } from '../filters/utils';
import ColorItem from './ColorItem';

interface ColorDescriptionProps {
  rule: FormattingRule;
  colorSize?: number;
}

const ColorDescription: React.FC<ColorDescriptionProps> = ({ rule, colorSize }) => {
  const { formattingConditions, fallbackLogic } = rule;

  const conditionWithoutLast = fallbackLogic ? formattingConditions.slice(0, -1) : formattingConditions;
  const fallbackCondition = fallbackLogic ? formattingConditions.at(-1) : undefined;
  return (
    <Box sx={{ ...flex.row, gap: 1 }}>
      {conditionWithoutLast.map((v, index) => {
        const condition = Object.keys(v.filter!.expression!.numberCondition || {})[0];
        return (
          <Box key={generateUUID()} sx={{ ...flex.center, gap: 1 }}>
            <Box sx={{ ...flex.row, whiteSpace: 'nowrap' }}>
              {condition === NumberConditionType.BETWEEN ? (
                `${v.filter!.expression!.numberCondition![condition]?.from || ''}-${
                  v.filter!.expression!.numberCondition![condition]?.to || ''
                }`
              ) : (
                <>
                  {operatorLabels[condition]}
                  {v.filter!.expression!.numberCondition![condition] || ''}
                </>
              )}
            </Box>
            <ColorItem item={v.color} size={colorSize} />
            {index !== rule.formattingConditions.length - 1 && <Divider orientation="vertical" />}
          </Box>
        );
      })}
      {fallbackLogic && fallbackCondition && (
        <Box sx={{ ...flex.center }}>
          <ColorItem item={fallbackCondition.color} size={colorSize} />
        </Box>
      )}
    </Box>
  );
};

export default ColorDescription;
